export default __webpack_public_path__ + "static/media/AddIcon.5aa18366.svg";